/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Condenser } from "./modelCondenser";

class ControllerCondenser extends ControllerModel {
  constructor() {
    super("ControllerCondenser");
    
    this.setNewNode = (callback) => {
      let condenser = new Condenser();
      condenser.decorate(callback);

      this.addNode(condenser);
      SingletonFlowchart.SaveStatus();
    }

    this.loadNode = (node, callback) => {
      let condenser = new Condenser();
      condenser.copyFrom(node);
      condenser.decorate(callback);
      this.addNode(condenser)
    }

    this.getProperties = async (node) => {
      let n = new Condenser();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Condenser();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerCondenser };
